import { Articulation } from 'types/articulation';
import ArticulationCreditItemDetails from 'components/credits/credit-details/ArticulationCreditItemDetails';
import { CreditItemDetailsBanner } from 'components/credits/credit-details/CreditItemDetailsBanner';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import { Precedent } from 'types/precedent';
import PrecedentCreditItemDetails from 'components/credits/credit-details/PrecedentCreditItemDetails';
import SkipNavLocation from 'components/common/SkipNavLocation';

type Props =
  | { creditType: CreditType.ARTICULATION; articulation: Articulation }
  | { creditType: CreditType.PRECEDENT; precedent: Precedent };

export default function CreditItemDetails(props: Props): JSX.Element | null {
  return (
    <FlexContainer className='credit-item-details'>
      <SkipNavLocation>
        <CreditItemDetailsBanner {...props} />
      </SkipNavLocation>
      {props.creditType === CreditType.ARTICULATION ? (
        <ArticulationCreditItemDetails articulation={props.articulation} />
      ) : (
        <PrecedentCreditItemDetails precedent={props.precedent} />
      )}
    </FlexContainer>
  );
}
